import * as React from 'react';

import {FeatureCard} from 'shells/ai-homepage/ai-feature-card/feature-card';
import {FeatureCardGrid} from 'shells/grid-list/feature-card-grid';

import {appHistory} from '../../../../history';

import type {Offer} from './offers-config';
import {ROADMAP_OFFER_ID, getActiveOffers} from './offers-config';

export function OffersGrid() {
    const items: Offer[] = React.useMemo(() => {
        const activeOffers = getActiveOffers();

        return activeOffers;
    }, []);

    const getOnClick = React.useCallback((offer: Offer) => {
        if (offer.id === ROADMAP_OFFER_ID) {
            return () => window.open('https://my.demio.com/ref/Z5EWy4cKBjUvUTIj', '_blank');
        }

        return undefined;
    }, []);

    const renderCard = React.useCallback(
        (offer: Offer) => {
            const thumbnail = offer.illustration
                ? {illustration: offer.illustration, backgroundColor: 'tagBlueLt'}
                : undefined;

            const onClick = getOnClick(offer);
            const ctaText = offer.linkCTA || 'Explore';

            const cta =
                onClick || offer.exploreLink
                    ? {
                          text: ctaText,
                          ...(onClick
                              ? {onClick, actionType: offer.actionType}
                              : {
                                    actionType: offer.actionType || 'routed-link',
                                    url: offer.exploreLink,
                                    newTab: false,
                                }),
                      }
                    : undefined;

            return (
                <FeatureCard
                    title={offer.title}
                    description={offer.description}
                    history={appHistory}
                    exploreLink={offer.exploreLink}
                    // @ts-expect-error
                    thumbnail={thumbnail}
                    variant='feature'
                    icon={offer.icon}
                    cta={cta}
                />
            );
        },
        [getOnClick]
    );

    const hasIllustration = React.useCallback((offer: Offer) => {
        return Boolean(offer.illustration);
    }, []);

    const getKey = React.useCallback((offer: Offer) => {
        return offer.id;
    }, []);

    return (
        <>
            <FeatureCardGrid
                items={items}
                renderCard={renderCard}
                hasIllustration={hasIllustration}
                getKey={getKey}
            />
        </>
    );
}
